module.exports = ".standard-inactive {\r\n\tcolor: #999;\r\n}\r\n\r\ntr {\r\n    cursor: pointer; \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/standards/standard-calibration-list/standard-calibration-list.component.css
// module id = ./src/app/standards/standard-calibration-list/standard-calibration-list.component.css
// module chunks = main